/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./warning-message.component.scss.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./warning-message.component";
var styles_WarningMessageComponent = [i0.styles];
var RenderType_WarningMessageComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_WarningMessageComponent, data: {} });
export { RenderType_WarningMessageComponent as RenderType_WarningMessageComponent };
export function View_WarningMessageComponent_0(_l) { return i1.ɵvid(2, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "message p-4 text-12"]], null, null, null, null, null)), i1.ɵncd(null, 0)], null, null); }
export function View_WarningMessageComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-warning-message", [], null, null, null, View_WarningMessageComponent_0, RenderType_WarningMessageComponent)), i1.ɵdid(1, 114688, null, 0, i2.WarningMessageComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var WarningMessageComponentNgFactory = i1.ɵccf("app-warning-message", i2.WarningMessageComponent, View_WarningMessageComponent_Host_0, {}, {}, ["*"]);
export { WarningMessageComponentNgFactory as WarningMessageComponentNgFactory };
